module.exports = __webpack_public_path__ + "img/gl.b17853b3.png";